// cleanup_convert_to_typescript_file_LOGIN_WORKFLOW
// cleanup_convert_to_glu_component_LOGIN_WORKFLOW

import React, { useRef, useEffect } from 'react';
import classnames from 'classnames';
import { Button, PRIMARY, TERTIARY } from '@glu/buttons-react';
import PropTypes from 'prop-types';
import { JSSClasses } from 'proptypes/jss-prop-types';
import { challengeTypes } from 'constants.js';
import useLocale from 'components/useLocale';

import Input from '../gluValidation/Input';
import Checkbox from '../checkbox/Checkbox';

const VIP = ({
  classes: { centerContent, error, inputField, inputSection, rememberMe },
  data: { challengeFirstAttempt, challengeType },
  deviceChallenge,
  isSubmitting,
  onCancel,
  onChange,
  onChecked,
  onKeyDown,
  onSubmitForm,
  rememberMeFlag,
  validate,
  vipTokens
}) => {
  const locale = useLocale();
  const isVipUnavailable = challengeType === challengeTypes.VIP_UNAVAILABLE;
  const isVipActivation = challengeType === challengeTypes.VIP_ACTIVATION;
  const inputRef = useRef();

  useEffect(() => {
    if (inputRef?.current) {
      setTimeout(() => {
        inputRef?.current?.focus();
      }, 500);
    }
  }, [inputRef?.current]);
  return (
    <>
      <div>
        <div className="modal-header">{locale['challengeManager.title']}</div>
        {!isVipUnavailable && (
          <div className="text">
            {`${locale['challengeManager.enterTokenCode']} ${
              isVipActivation ? locale['challengeManager.nextTokenCode'] : ''
            }`}
          </div>
        )}
      </div>
      <div className={classnames(inputSection, centerContent)}>
        <div className={inputField}>
          {!isVipUnavailable && (
            <>
              <Input
                autoCorrect="off"
                className="form-group"
                data-qa="vip-token1"
                disabled={isSubmitting}
                forwardedRef={inputRef}
                id="vip-token1"
                label={locale['challengeManager.labelTokencode']}
                name="token1"
                type="text"
                onChange={onChange}
                validators={[{ required: true, msg: locale['validation.required'] }]}
                onKeyDown={onKeyDown}
              />
              {isVipActivation && (
                <Input
                  autoCorrect="off"
                  className="form-group"
                  data-qa="vip-token2"
                  disabled={isSubmitting}
                  id="vip-token2"
                  label={locale['challengeManager.labelNextTokencode']}
                  name="token2"
                  type="text"
                  onChange={onChange}
                  validators={[{ required: true, msg: locale['validation.required'] }]}
                  onKeyDown={onKeyDown}
                />
              )}
            </>
          )}
          <span className={error} data-qa="error-content" data-testid="error-content">
            {isVipUnavailable && locale['challengeManager.vipUnavailable']}
            {!isVipUnavailable &&
              !challengeFirstAttempt &&
              `${isVipActivation ? locale['common.invalidCodes'] : locale['common.invalidCode']}.`}
          </span>
        </div>
      </div>
      {deviceChallenge && !isVipUnavailable && (
        <div className={rememberMe}>
          <label htmlFor="rememberMe">
            <Checkbox
              onChange={(e) => onChecked(e.target.checked)}
              checked={rememberMeFlag}
              name="rememberMe"
              id="rememberMe"
              data-qa="rememberMe"
            />
            <span className="bold">{locale['challengeManager.rememberDevice']}</span>
          </label>
        </div>
      )}
      <section>
        {!isVipUnavailable && (
          <Button
            className="btn btn-primary"
            data-qa="modal-notification-primary-btn"
            text={isSubmitting ? locale['common.submittingPleaseWait'] : locale['common.continue']}
            disabled={Object.keys(vipTokens) === 0 || isSubmitting}
            variant={PRIMARY}
            onClick={async (e) => {
              const { isValid } = await validate();
              if (isValid) onSubmitForm(e);
            }}
            data-testid="continueButton"
          />
        )}
        <Button
          className="btn btn-tertiary"
          onClick={onCancel}
          data-qa="modal-notification-secondary-btn"
          text={locale['common.cancel']}
          variant={TERTIARY}
          data-testid="cancelButton"
        />
      </section>
    </>
  );
};

VIP.propTypes = {
  classes: JSSClasses.isRequired,
  data: PropTypes.shape({}).isRequired,
  deviceChallenge: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onChecked: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onSubmitForm: PropTypes.func.isRequired,
  rememberMeFlag: PropTypes.bool.isRequired,
  vipTokens: PropTypes.shape({
    token1: PropTypes.string,
    token2: PropTypes.string
  }),
  validate: PropTypes.func.isRequired
};

VIP.defaultProps = {
  vipTokens: undefined
};

export default VIP;
